// Single dayjs entry point for the app — replaces moment.js (Issue 22).
// dayjs ships ~2 KB vs moment's ~300 KB and has the same formatting API.
// customParseFormat enables strict parsing like dayjs(str, 'DD/MM/YYYY', true).
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export default dayjs;
